import { SET_DOCTORS, UPDATE_DOCTORS, SET_PHONE } from '../actionTypes';

/**
 * 设置医生列表的 action creator
 * @param {Array} doctors - 医生对象数组
 * @returns {Object} action 对象
 */
export const setDoctors = (doctors) => ({
    type: SET_DOCTORS,
    payload: doctors,
});

/**
 * 批量更新医生信息的 action creator
 * @param {Array} ids - 医生的唯一标识符数组
 * @param {Object} updates - 要更新的医生信息
 * @returns {Object} action 对象
 */
export const updateDoctors = (ids, updates) => ({
    type: UPDATE_DOCTORS,
    payload: {
        ids,
        updates: updates,
    },
});

/**
 * 设置URL参数中的手机号
 * @param {string} phone - 手机号
 * @returns {Object} action 对象
 */
export const setPhone = (phone) => ({
    type: SET_PHONE,
    payload: phone,
});
